import type { IXShareSelection } from "~/feature/chart/components/XShareDialog/types";
import { ChartViewEnum } from "~/feature/chart/types";
import { getMarketGroupId, isConsensusAvailable } from "~/feature/chart/utils";
import type { IMarket } from "~/types/event";

export const getDefaultXShareSelection = (
  markets: IMarket[],
  selections: string[],
  viewMode: ChartViewEnum
): IXShareSelection | null => {
  const target = markets.find(({ id }) => id === selections[0]) ?? markets[0];

  if (!target) {
    return null;
  }

  const isConsensus =
    viewMode === ChartViewEnum.CONSENSUS &&
    isConsensusAvailable(markets, [target.id]);

  return {
    groupId: getMarketGroupId(target),
    marketId: isConsensus ? null : target.id,
  };
};
